export default function (Vue) {
  const VueUndefinedToString = (value) => {
    return value === undefined 
      ? ''
      : value
  }
  Vue.filter('undToStr', VueUndefinedToString)
}



// WEBPACK FOOTER //
// ./src/modules/filters/UndefinedToString.js